import Bowser from "bowser";

export const browser = Bowser.getParser(window.navigator.userAgent);

export const isSafari = browser && browser.satisfies({ safari: ">=0" });

export const isFirefox = browser && browser.satisfies({ firefox: ">=0" });
